import React from "react";
import { BodyDiv } from "~/components/typography";
import { safeHref, sanitizeHtml } from "~/utils/sanitize_html";
import LocationIcon from "~/components/icons/location";
import JobIcon from "~/components/icons/job";
import { useTrackingParams } from "~/hooks/use_tracking_params";
import type { FeaturedBoardJobPost } from "~/types/jben/board";
import { useBoardConfiguration } from "~/hooks/use_board_configuration";

interface Props {
  featuredPost: FeaturedBoardJobPost;
}

const FeaturedPost = ({ featuredPost }: Props) => {
  const { withTrackingParams } = useTrackingParams();
  const { preview_mode } = useBoardConfiguration();

  const Wrapper = preview_mode
    ? (props: { children: React.ReactNode }) => <div>{props.children}</div>
    : (props: { children: React.ReactNode }) => (
        <a href={safeHref(withTrackingParams(featuredPost.absolute_url))} target="_top">
          {props.children}
        </a>
      );
  return (
    <Wrapper>
      <div className={"featured-posts__card"}>
        <p className={"body body--medium featured-posts__title"}>{featuredPost.title}</p>
        <div className={"featured-posts__tags"}>
          {featuredPost.location && (
            <div className={"featured-posts__tag"}>
              <LocationIcon size="md" />
              <p className={"body body__secondary body--metadata featured-posts__tag-text"}>
                {featuredPost.location}
              </p>
            </div>
          )}
          {featuredPost.payRange && (
            <div className={"featured-posts__tag"}>
              <JobIcon size="md" />
              <p className={"body body__secondary body--metadata featured-posts__tag-text"}>
                {featuredPost.payRange}
              </p>
            </div>
          )}
        </div>
        <div className={"featured-posts__content"}>
          <BodyDiv>
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(featuredPost.content) }}></div>
          </BodyDiv>
        </div>
      </div>
    </Wrapper>
  );
};

export default FeaturedPost;
